import React from 'react';
import usePageTracking from '../../hooks/usePageTracking';

/**
 * A wrapper component that applies page tracking to its children.
 * @param {object} props
 * @param {string} props.pageName - The human-readable name of the page to track.
 * @param {React.ReactNode} props.children - The page component to render.
 */
const PageTracker = ({ pageName, children }) => {
  // This hook automatically tracks page views and time spent.
  usePageTracking(pageName);

  // Render the actual page component that was passed in.
  return <>{children}</>;
};

export default PageTracker;
